import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useAccountContext } from 'pages/settings/pages/personal/pages/account/context/accountContext'
import { SecurityStore } from '../store/securityStore'

export const SecurityContext = createContext<SecurityStore | null>(null)

export const useSecurityContext = () => {
  const context = useContext(SecurityContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SecurityContext')

  return context
}

export const SecurityProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const accountStore = useAccountContext()
  const [store] = useState(() => new SecurityStore(accountStore, entities))

  useEffect(() => {
    void store.init()
  }, [store])

  return <SecurityContext.Provider value={store}>{children}</SecurityContext.Provider>
}
